import React from "react";
import { Box, LinearProgress, Stack, Typography } from "@mui/material";
import styled from "@emotion/styled";

const StyledTypography = styled(Typography)(() => ({
  fontWeight: 500,
}));

const CarePlanProgress = ({
  progressValue,
  titleColor = "#212121",
  color = "primary",
  text = "Care Plan Progress",
}) => {
  return (
    <Stack padding="8px 0 16px 0" gap="4px" width="100%">
      <Box
        display="flex"
        alignItems="center"
        gap="8px"
        justifyContent="space-between"
      >
        <StyledTypography variant="caption" color={titleColor}>
          {text}
        </StyledTypography>
        <StyledTypography variant="caption" color={titleColor}>
          {progressValue}% Complete{" "}
        </StyledTypography>
      </Box>
      <Box sx={{ width: "100%" }} height="9px">
        <LinearProgress
          color={color}
          value={progressValue}
          variant="determinate"
          sx={{
            height: "100%",
            borderRadius: "4px",
            // backgroundColor: "#3DC583 !important",
          }}
        />
      </Box>
    </Stack>
  );
};

export default CarePlanProgress;
